import { render, staticRenderFns } from "./EventCategoryModal.vue?vue&type=template&id=07ff7127&scoped=true&"
import script from "./EventCategoryModal.vue?vue&type=script&lang=js&"
export * from "./EventCategoryModal.vue?vue&type=script&lang=js&"
import style0 from "./EventCategoryModal.vue?vue&type=style&index=0&id=07ff7127&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ff7127",
  null
  
)

export default component.exports